export const TOKEN_KEY = 'auth_token';
export const USER_KEY = 'auth_user';
export const TOKEN_EXPIRY_KEY = 'auth_token_expiry';
